export const GET_REPORT_RESULTS = 'GET_REPORT_RESULTS'
